import React, { Component } from 'react';
//import Ticker from 'react-ticker'
import Marquee from 'react-css-marquee'

import './TitleLoop.scss';

class TitleLoop extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const title = this.props.title; 


    return (
      <Marquee text={title} disableDefaultStyles={true} direction="left" speed={1} spacing={1} />
    )
  }
}

export default TitleLoop;
